export const EMBED_YOUTUBE_CONFIG = {
    name        : 'Youtube',
    icon        : 'i5-youtube',
    iconSvg     : 'isvg-youtube',
    description : 'Embeded youtube',
    embedCode   : '',
    projectIcon : 'youtube',                    // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['youtube.com', 'youtu.be']   // required for embedCode content search for autodetect EmbedType
}
